class Subscribe extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.setup();
        this.handleInput();
        this.formSubmit();

    }
    setup() {
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this.querySelector('.subscribe-inner'), start: 'top 80%' },
            tweenArr: [
                new FadeIn({ el: this.querySelector('.subscribe-main'), from: { y: parseRem(20) } }),
                new RevealText({ el: this.querySelector('.subscribe-main-title .txt'), color: "white", delay: "<=0" }),
                new FadeIn({ el: this.querySelector('.subscribe-form-inner .input-wrap'), from: { y: parseRem(20) } }),
                new FadeIn({ el: this.querySelector('.subscribe-form-inner .btn-wrap'), from: { y: parseRem(20) } }),
                new ScaleLine({ el: this.querySelector('.subscribe-form-inner .div-line') }),
                new FadeSplitText({ el: this.querySelector('.subscribe-main-label .txt') })
            ]
        });
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this.querySelector('.subscribe-inner'), start: 'top 80%' },
            tweenArr: [
                ...Array.from(this.querySelectorAll('.subscribe-list-item')).flatMap((item, idx) => {
                    let delayI = (index, initDelay = .1) => (index !== 0 ? initDelay * (index + 1) : initDelay);
                    return [
                        new FadeIn({ el: item.querySelector('.subscribe-list-item-ic'), from: { y: parseRem(20) }, delay: delayI(idx) }),
                        new FadeSplitText({ el: item.querySelector('.subscribe-list-item-title .txt'), breakType: "words", delay: delayI(idx, 0.15) }),
                        new FadeSplitText({ el: item.querySelector('.subscribe-list-item-sub .txt'), breakType: "words", delay: delayI(idx, 0.15) }),
                    ];
                }),
            ]
        });
    }
    validateEmail(email) {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{3,}$/;
        return regex.test(email);
    }
    formSubmit() {
        const form = this.querySelector('.subscribe-form');
        // checking when remove type email when inspect
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const email = e.target.querySelector('input[type="email"]');
            const emailValue = email.value;

            if (this.validateEmail(emailValue.trim())) {
                //submit here 
                console.log('valid');

                fetch("https://a.klaviyo.com/client/profiles/?company_id=X2GESt", {
                    "headers": {
                        "accept": "application/json",
                        "cache-control": "no-cache",
                        "content-type": "application/json",
                        "pragma": "no-cache",
                        "priority": "u=1, i",
                        "revision": "2024-10-15",
                        "x-klaviyo-js-url": "path",
                        "x-klaviyo-onsite": "1"
                    },
                    "body": JSON.stringify({
                        data: {
                            attributes: {
                                email: emailValue,
                            },
                            type: "profile"
                        }
                    }),
                    "method": "POST",
                    "mode": "cors",
                    "credentials": "omit"
                }).then(res => {
                    email.closest('.input-wrap').classList.remove('on-error');
                    email.closest('.input-wrap').classList.remove('has-value');
                    email.closest('.input-wrap').classList.add('on-success');
                    this.querySelector('.subscribe-main-label').classList.add('on-success');
                    this.querySelector('.subscribe-main-label').classList.remove('on-error');
                    email.value = '';
                    email.blur()
                }).catch(err => {
                    email.closest('.input-wrap').querySelector('.input-error').innerHTML = 'Error when submiting, please try again later.'
                });


            } else {
                if (emailValue.length > 0) {
                    email.closest('.input-wrap').querySelector('.input-error').innerHTML = 'Please enter a valid email.'
                } else {
                    email.closest('.input-wrap').querySelector('.input-error').innerHTML = 'This field is required.'
                }
                console.log('invalid');
                email.closest('.input-wrap').classList.add('on-error');
                this.querySelector('.subscribe-main-label').classList.add('on-error')
            }
        })
    }
    handleInput() {
        let allInputs = this.querySelectorAll('input');
        let timer = null;

        allInputs.forEach(input => {
            input.addEventListener('focus', () => {
                input.closest('.input-wrap').classList.add('on-focus');

                if (!input.value.trim()) {
                    input.closest('.input-wrap').classList.remove('on-success');
                    this.querySelector('.subscribe-main-label').classList.remove('on-success');
                }
            })
            input.addEventListener('blur', () => {
                input.closest('.input-wrap').classList.remove('on-focus');

                if (!input.value.trim()) {
                    input.closest('.input-wrap').classList.remove('on-error');
                    this.querySelector('.subscribe-main-label').classList.remove('on-error');
                }
            })
            input.addEventListener('input', () => {
                if (input.value.length > 0) {
                    input.closest('.input-wrap').classList.add('has-value');
                    input.closest('.input-wrap').classList.remove('on-success');
                    input.closest('.input-wrap').classList.remove('on-error');
                    this.querySelector('.subscribe-main-label').classList.remove('on-error');
                    this.querySelector('.subscribe-main-label').classList.remove('on-success')
                } else {
                    input.closest('.input-wrap').classList.remove('has-value');
                };
            })
            // toggle .on-error class on invalid input sample
            input.addEventListener('invalid', (e) => {
                e.preventDefault()
                console.log('invalid');
                if (input.value.trim()) {
                    input.closest('.input-wrap').querySelector('.input-error').innerHTML = 'Please enter a valid email.'
                } else {
                    input.closest('.input-wrap').querySelector('.input-error').innerHTML = 'This field is required.'
                };
                if (timer) clearTimeout(timer);

                timer = setTimeout(() => {
                    input.closest('.input-wrap').classList.add('on-error');
                    this.querySelector('.subscribe-main-label').classList.add('on-error')
                }, 50)
            })
        })
    }
}

customElements.define("home-subscribe", Subscribe);
